<script lang="ts">
    import {BicycleIcon, CarIcon, LoadingIcon, PedestrianIcon, TruckIcon, } from "@anyways-open/common-svgs";
    import { appManager } from "../../../../../../AppManager";
    import {get} from "svelte/store";
    import type { MatrixAssignmentRowManager } from "./MatrixAssignmentRowManager";

    export let manager: MatrixAssignmentRowManager;

    let visible = manager.visible;
    let profile = manager.profile;
    let color = manager.color;

    let profiles = manager.getAvailableProfiles();
    let canRemove = manager.getCanRemove();
    let progress = manager.getProgress();
    let isVisible = manager.getIsVisible(); // the visible state can also depend on the parent.

    let colorToUser: string = "yellow";

    $: {
        visible = manager.visible;
        profile = manager.profile;
        color = manager.color;
        
        canRemove = manager.getCanRemove();
        progress = manager.getProgress();
        isVisible = manager.getIsVisible();

        colorToUser = $color.color;
        if ($color.visualizationType === "bicycle.safety") {
            colorToUser = "yellow";
        }
    }

    async function onRemove(): Promise<void> {
        await manager.delete();
    }

    async function onCopy(): Promise<void> {
        await manager.copy();
    }

    function getVehiceType(profile: string): string {
        return profile.substring(0, profile.indexOf("."));
    }
    
    async function openSettingsModal(){
        const result = await appManager.ModalHooks.TripsLayerSettingsModal.open(get(color))
        if(result === "cancelled"){
            return
        }

        color.set(result);
    }
    
</script>

<div class="row ps-3 pe-0 gx-0" style="border-bottom: 1px; border-color: black;">
    <div class="d-flex" >
        <div class="svg-icon-sm pe-1 fs-tool {$isVisible ? '' : 'low-opacity'}">
            {#if getVehiceType($profile) == "car"}
                <CarIcon />
            {:else if getVehiceType($profile) == "bicycle"}
                <BicycleIcon />
            {:else if getVehiceType($profile) == "pedestrian"}
                <PedestrianIcon />
            {:else if getVehiceType($profile) == "bigtruck"}
                <TruckIcon />
            {/if}
        </div>
        <select
            class="fs-tool form-select form-select-tool {$isVisible ? '' : 'low-opacity'}"
            bind:value={$profile} disabled={!$isVisible}>
            {#each profiles as profile}
                <option value={`${profile}`}>
                    {`${profile}`}
                </option>
            {/each}
        </select>

        <div class="btn rounded-circle badge-color-picker {$isVisible ? '' : 'low-opacity'}" style={'background: '+colorToUser}
            on:click={async () => await openSettingsModal() }
        ></div>
        <div class="btn badge badge-rounded-circle badge-success-soft ms-1 {$isVisible ? '' : 'low-opacity'} ">
            <i class="fe fe-copy" on:click={async () => await onCopy()} />
        </div>
        <div
            class="btn badge badge-rounded-circle badge-success-soft ms-1 {$isVisible ? '' : 'low-opacity'}"
            on:click={() => {
                $visible = !$visible;
            }}>
            {#if $visible}
                <i class="fe fe-eye" />
            {:else}
                <i class="fe fe-eye-off" />
            {/if}
        </div>

        <div
            class="btn badge badge-rounded-circle badge-success-soft ms-1 {!$canRemove
                ? 'disabled low-opacity'
                : ''} {$isVisible ? '' : 'low-opacity'}"
            on:click={async () => await onRemove()}>
            <i class="fe fe-trash-2" />
        </div>
    </div>

    {#if ($progress < 1 && $isVisible)}
        <div class="d-flex my-1" style="width: 100%; height: 25px;">
            <LoadingIcon style="margin-left: 25px; height: 100%; fill: black;"/>
            <div class="mode svelte-1wisec1" style="margin-top: 10px; background-color: {$color}; width: {Math.round($progress*100)}%; height: 25%;"></div>
        </div>
    {/if}
</div>

<style>
	.form-select-tiny {
		line-height: unset;
		background-position: right 0.625rem center;
		background-size: 0.75em;
		height: unset;
		padding: 0;
		width: 75px;
	}

	.badge-color-picker {
		margin-top: 2px;
	}

    .low-opacity {
        opacity: 0.25;
    }
</style>
